/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import DatePicker from "@/components/ui/DatePickerRange";
import { useAuth } from "@/context/AuthContext";
import { formatToYMD } from "@/lib/utils";
import { getsourcemedium } from "@/services/analytics";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {   Search,   } from "lucide-react";

import $ from "jquery";
import DataTable from "datatables.net-bs5";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const SourceMedium = () => {
  const navigate = useNavigate();

  const { user } = useAuth();
  const userId = user?.id;

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const skipInitialDate = useRef(true);
  const [userSelectedDate, setUserSelectedDate] = useState(false);

  // Pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  // Date Range
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  const handleDateRange = (rangeString: string) => {
    if (skipInitialDate.current) {
      skipInitialDate.current = false;
      return;
    }

    const [start, end] = rangeString.split("-");
    const formattedStart = formatToYMD(start);
    const formattedEnd = formatToYMD(end);

    setUserSelectedDate(true);
    setStartDate(formattedStart || null);
    setEndDate(formattedEnd || null);
    setPage(1);
  };

  const columns = [
    { label: "Project Name", key: "project_name" },
    // { label: "Project ID", key: "project_id" },
    { label: "Source", key: "source" },
    { label: "Medium", key: "medium" },
    {
      label: "Channel ",
      key: "channel",
    },
    {
      label: "Sessions ",
      key: "sessions",
    },
  ];

  // Fetch API
  useEffect(() => {
    loadData();
  }, [userId, startDate, endDate]);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await getsourcemedium(userId, startDate, endDate);

      setData(res.value || []);
      setTotalRecords(res.pagination?.total || 0);
    } catch (error) {
      console.error("Failed to fetch forms:", error);
      setData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  const tableRef = useRef<HTMLTableElement>(null);
  const tableInstance = useRef<any>(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!tableRef.current || data.length === 0) return;

    tableInstance.current?.destroy();

    tableInstance.current = new DataTable(tableRef.current, {
      destroy: true,
      searching: true,
      ordering: true,
      paging: false,
      pageLength: 10,

      // Hide default search and other controls
      layout: {
        topStart: null,
        topEnd: null,
        bottomStart: "info",
        bottomEnd: "paging",
      },
    });

    return () => tableInstance.current?.destroy();
  }, [data]);

  useEffect(() => {
    tableInstance.current?.search(search).draw();
  }, [search]);

  return (
    <div>
      <div className="container-fluid">
        <div className="social-dash-wrap">
          {/* Header */}

          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-main justify-content-lg-start card align-content-start p-2">
                <div className="align-content-center align-items-center card-body d-flex justify-content-between p-0 p-2 w-100">
                  <div className="">
                    <h3 className="text-xl mt-0.5 fw-600">
                      {/* <span className="text-primary text-xl"> */}
                      Source and Medium
                    </h3>
                  </div>

                  <div className="breadcrumb-action justify-content-center flex-wrap">
                    <div className="action-btn m-0">
                      <div className="flex items-center gap-4">
                        <div className="action-btn">
                          <div className="form-group mb-0 ">
                            {/* <div className="input-container icon-left position-relative border rounded p-1">
                              <DatePicker
                                placeholder="Select Date"
                                onDateChange={handleDateRange}
                              />
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="align-content-center align-items-center card-footer d-flex justify-content-between p-0 p-2 w-100">
                  <div className="">
                    <div className="border global-shadow ml-md-20 my-10 order-1 order-md-2 project-search project-search--height rounded">
                      <form
                        action="/"
                        className="d-flex align-items-center user-member__form"
                      >
                        <Search />
                        <input
                          className="form-control mr-sm-2 border-0 box-shadow-none"
                          type="search"
                          placeholder="Search by Name"
                          onChange={(e) => {
                            const value = e.target.value;

                            setSearch(value); // Always update input value

                            if (value.length >= 3 || value.length === 0) {
                              setSearch(value); // Trigger API only after 3+ chars or when cleared
                            }
                          }}
                        />
                      </form>
                    </div>
                  </div> 
                  <div className="breadcrumb-action justify-content-center flex-wrap gap-2 align-items-center"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="row">
            <div className="col-lg-12">
              <div className="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                <div className="landing-pages-table table-responsive ">
                  <table className="table table--default   " ref={tableRef}>
                    <thead>
                      <tr>
                        {columns.map((col, idx) => (
                          <th key={idx}>{col.label}</th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td
                            colSpan={columns.length + 1}
                            className="text-center py-5"
                          >
                            <div className="spin-container d-flex justify-content-center">
                              <div className="atbd-spin-dots spin-sm">
                                <span className="spin-dot badge-dot dot-primary"></span>
                                <span className="spin-dot badge-dot dot-primary"></span>
                                <span className="spin-dot badge-dot dot-primary"></span>
                                <span className="spin-dot badge-dot dot-primary"></span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : data.length === 0 ? (
                        <tr>
                          <td
                            colSpan={columns.length + 1}
                            className="text-center py-3"
                          >
                            No Forms found
                          </td>
                        </tr>
                      ) : (
                        data.map((row, index) => (
                          <tr key={index}>
                            {columns.map((col, cIdx) => (
                              <td key={cIdx}>{row[col.key]}</td>
                            ))}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SourceMedium;
